import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "history-of-changes-item" }
const _hoisted_2 = { class: "history-of-changes-item__container-content" }
const _hoisted_3 = { class: "history-of-changes-item__author-event" }
const _hoisted_4 = { class: "history-of-changes-item__content" }
const _hoisted_5 = { class: "history-of-changes-item__content-title" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { key: 5 }
const _hoisted_12 = { key: 6 }
const _hoisted_13 = { key: 7 }
const _hoisted_14 = { key: 8 }
const _hoisted_15 = { key: 9 }
const _hoisted_16 = { key: 10 }
const _hoisted_17 = { key: 11 }
const _hoisted_18 = { key: 12 }
const _hoisted_19 = { key: 13 }
const _hoisted_20 = { key: 14 }
const _hoisted_21 = { key: 15 }
const _hoisted_22 = { key: 16 }
const _hoisted_23 = { key: 17 }
const _hoisted_24 = { key: 18 }
const _hoisted_25 = { key: 19 }
const _hoisted_26 = { key: 20 }
const _hoisted_27 = { class: "history-of-changes-item__additional-slot" }
const _hoisted_28 = { class: "history-of-changes-item__user-date" }
const _hoisted_29 = { class: "history-of-changes-item__date" }
const _hoisted_30 = { class: "history-of-changes-item__performer-info" }

import { FlagIcon } from 'tir-style-system/icons/solid';
import { TirPmIconView } from 'tir-pm-icon-view';
import { computed, onMounted, PropType } from 'vue';
import { TaskHistoryModel } from './models';
import tirPmDateTransform from 'tir-pm-date-transform';
import utc from 'tir-pm-date-transform/plugin/utc';
import { ActionEnum } from './enums/ActionEnum';
import { TirPmSelectBadge } from 'tir-pm-select-badge';
import { TirPmIndicator } from 'tir-pm-indicator';
import {
  CheckIcon,
  ClockIcon,
  EyeIcon,
  ConnectIcon,
  ChartBarIcon,
  UserCircleIcon,
  PencilSquareIcon,
  PaperClipIcon,
  TagIcon,
  TrashIcon,
} from 'tir-style-system/icons/outline';
import {
  TirPmStatus,
  TirPmStatusBgEnum,
  TirPmStatusTextEnum,
  TirPmTooltipElement,
  TirPmTooltipElementPlacementEnum,
} from 'tir-components';
import { TirPmFilePreview, IFilePreview } from 'tir-pm-file-preview';
import { CurrentUser } from 'tir-pm-user-core';

/**Параметры компонента */

export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryOfChangesItem',
  props: {
    historyItemData: {}
  },
  setup(__props: any) {

const props = __props;



/** Данные которые могут измениться */
const historyItemDataComputed = computed(() => {
  return props.historyItemData;
});

/** Трансформировать имя */
const transformNameComputed = computed(() => {
  return `${historyItemDataComputed.value.Performer.FirstName} ${historyItemDataComputed.value.Performer?.LastName[0]}.`;
});
/**Получить часовой пояс */
const correctDate = computed(() => {
  const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(Z)?$/;

  const checkCorrectDate = regex.test(String(historyItemDataComputed.value.Value.Value));
  const value = historyItemDataComputed.value.Value.Value;

  if (checkCorrectDate) {
    if (value.at(-1) !== 'Z') {
      const stringDate = value + 'Z';
      return new Date(stringDate);
    } else {
      return new Date(value);
    }
  } else {
    const timeZone = -new Date(value).getTimezoneOffset() / 60;
    const date = new Date(value);
    date.setHours(date.getHours() + timeZone);
    return date;
  }
});
/**Форматирование времени */
const formatedDate = computed(() => {
  return `${tirPmDateTransform(correctDate.value).format('DD.MM.YYYY')} в ${tirPmDateTransform(
    correctDate.value,
  ).format('HH:mm')}`;
});

// /** Utc смещение */
// const timeOffsetForUtc = (new Date().getTimezoneOffset() / 60) * -1;

const getDateTransform = (date: Date) => {
  let transformedDate = tirPmDateTransform(date).utc(true).utcOffset().format('DD.MM.YYYY HH:mm');
  return {
    date: transformedDate.slice(' ')[0],
    time: transformedDate.slice(' ')[1],
  };
};

/** Трансформировать имя */
const computedPerformerShortName = computed(() => {
  const parts = historyItemDataComputed.value.Value.AuthorFullName.split(' ');
  const firstNameLetter = parts[0]?.[0] || '';
  const lastNameLetter = parts[1]?.[0] || '';
  return `${lastNameLetter}${firstNameLetter}`;
});

const computedFilePreview = computed(() => {
  return {
    FileId: 0,
    Url: historyItemDataComputed.value.Value.ActionUrl,
    Name: historyItemDataComputed.value.Value.ActionUrl,
    Size: 0,
    Accesses: [],
  };
});

// const awdawd = {
//   FileId: 0,
//   Url:
// };

onMounted(() => {
  tirPmDateTransform.extend(utc as any);
});
// historyItemData

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["history-of-changes-item__left-indicator", {
            'history-of-changes-item__left-indicator--check':
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).CreateTask ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).TransferTask ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateType,
            'history-of-changes-item__left-indicator--addobserver':
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).CreateTask ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AddObserver,
            'history-of-changes-item__left-indicator--removeobserver':
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveObserver ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveFile ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemovePerformer,
            'history-of-changes-item__left-indicator--updatedateend':
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateDateEnd,
          }])
        }, [
          (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdatePriority)
            ? (_openBlock(), _createBlock(_unref(FlagIcon), {
                key: 0,
                style: _normalizeStyle({ color: historyItemDataComputed.value.Value.ActionColor })
              }, null, 8, ["style"]))
            : _createCommentVNode("", true),
          (
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).CreateTask ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).TransferTask ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateType
            )
            ? (_openBlock(), _createBlock(_unref(CheckIcon), { key: 1 }))
            : _createCommentVNode("", true),
          (
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AddObserver ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveObserver
            )
            ? (_openBlock(), _createBlock(_unref(EyeIcon), { key: 2 }))
            : _createCommentVNode("", true),
          (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateDateEnd)
            ? (_openBlock(), _createBlock(_unref(ClockIcon), { key: 3 }))
            : _createCommentVNode("", true),
          (
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AttachSubtask ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveSubtask ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).SetParent ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveParent
            )
            ? (_openBlock(), _createBlock(_unref(ConnectIcon), { key: 4 }))
            : _createCommentVNode("", true),
          (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateDifficulty)
            ? (_openBlock(), _createBlock(_unref(ChartBarIcon), {
                key: 5,
                style: _normalizeStyle({ color: historyItemDataComputed.value.Value.ActionColor })
              }, null, 8, ["style"]))
            : _createCommentVNode("", true),
          (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateStatus)
            ? (_openBlock(), _createBlock(_unref(TirPmIndicator), {
                key: 6,
                size: "s",
                customColor: historyItemDataComputed.value.Value.ActionColor
              }, null, 8, ["customColor"]))
            : _createCommentVNode("", true),
          (
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AddPerformer ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemovePerformer
            )
            ? (_openBlock(), _createBlock(_unref(UserCircleIcon), { key: 7 }))
            : _createCommentVNode("", true),
          (
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateName ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateDescription
            )
            ? (_openBlock(), _createBlock(_unref(PencilSquareIcon), { key: 8 }))
            : _createCommentVNode("", true),
          (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AttachFile)
            ? (_openBlock(), _createBlock(_unref(PaperClipIcon), { key: 9 }))
            : _createCommentVNode("", true),
          (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveFile)
            ? (_openBlock(), _createBlock(_unref(TrashIcon), { key: 10 }))
            : _createCommentVNode("", true),
          (
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AttachTag ||
              Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveTag
            )
            ? (_openBlock(), _createBlock(_unref(TagIcon), {
                key: 11,
                style: _normalizeStyle({ color: historyItemDataComputed.value.Value.ActionColor })
              }, null, 8, ["style"]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(transformNameComputed.value) + " ", 1),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).CreateTask)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " cоздал задачу "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).TransferTask)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, " перенес(-ла) тикет из другой очереди со статусом: "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AddObserver)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, " добавил(а) наблюдателей "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveObserver)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, " удалил(а) наблюдателей "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateDateEnd)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " установил новый дедлайн " + _toDisplayString(formatedDate.value), 1))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateType)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, " поменял(а) тип на \"" + _toDisplayString(historyItemDataComputed.value.Value?.Value) + "\" ", 1))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateDifficulty)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " поменял(а) сложность на \"" + _toDisplayString(historyItemDataComputed.value.Value?.Value) + "\" ", 1))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AttachSubtask)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, " добавил(а) подзадачи: "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateStatus)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, " поменял(а) статус: "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AddPerformer)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, " добавил(а) исполнителей: "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemovePerformer)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, " удалил(а) исполнителей: "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, " изменил(а) название на: \"" + _toDisplayString(historyItemDataComputed.value.Value?.Value) + "\" ", 1))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdatePriority)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, " поменял(а) приоритет на: \"" + _toDisplayString(historyItemDataComputed.value.Value?.Value) + "\" ", 1))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AttachTag)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, " добавил(а) теги: "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveTag)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, " убрал(а) теги: "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateDescription)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, " отредактировал(а) описание "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveSubtask)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, " убрал(а) подзадачи: "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveFile)
              ? (_openBlock(), _createElementBlock("span", _hoisted_23, " удалил(а) файлы: \"" + _toDisplayString(historyItemDataComputed.value.Value?.Value) + "\" ", 1))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AttachFile)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, " добавил(а) файлы: "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).SetParent)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, " прикрепил(а) родительский тикет "))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveParent)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, " открепил(а) родительский тикет "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_unref(TirPmTooltipElement), {
              width: "max-content",
              position: _unref(TirPmTooltipElementPlacementEnum).Right
            }, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString(historyItemDataComputed.value.Value.AuthorFullName), 1)
              ]),
              default: _withCtx(() => [
                (
                  Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AddObserver ||
                  Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveObserver ||
                  Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AddPerformer ||
                  Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemovePerformer
                )
                  ? (_openBlock(), _createBlock(_unref(TirPmIconView), {
                      key: 0,
                      colorCode: historyItemDataComputed.value.Value.ActionColor,
                      imageLoadUrl: historyItemDataComputed.value.Value.ActionUrl,
                      size: 24,
                      isBordered: "",
                      isRounded: ""
                    }, {
                      mainSlot: _withCtx(() => [
                        _createTextVNode(_toDisplayString(computedPerformerShortName.value), 1)
                      ]),
                      _: 1
                    }, 8, ["colorCode", "imageLoadUrl"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["position"]),
            (
                Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AttachSubtask ||
                Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).SetParent
              )
              ? (_openBlock(), _createBlock(_unref(TirPmSelectBadge), { key: 0 }, {
                  sign: _withCtx(() => [
                    _createTextVNode(_toDisplayString(historyItemDataComputed.value.Value?.TaskId), 1)
                  ]),
                  iconViewAddon: _withCtx(() => [
                    _createVNode(_unref(TirPmIconView), {
                      size: 24,
                      isBordered: false,
                      isRounded: "",
                      colorCode: historyItemDataComputed.value.Value.ActionColor,
                      imageLoadUrl: historyItemDataComputed.value.Value.ActionUrl
                    }, {
                      mainSlot: _withCtx(() => []),
                      _: 1
                    }, 8, ["colorCode", "imageLoadUrl"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (
                Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveSubtask ||
                Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveParent
              )
              ? (_openBlock(), _createBlock(_unref(TirPmSelectBadge), { key: 1 }, {
                  sign: _withCtx(() => [
                    _createTextVNode(_toDisplayString(historyItemDataComputed.value.Value?.TaskId), 1)
                  ]),
                  iconViewAddon: _withCtx(() => [
                    _createVNode(_unref(TirPmIconView), {
                      size: 24,
                      isBordered: false,
                      isRounded: "",
                      colorCode: historyItemDataComputed.value.Value.ActionColor,
                      imageLoadUrl: historyItemDataComputed.value.Value.ActionUrl
                    }, {
                      mainSlot: _withCtx(() => []),
                      _: 1
                    }, 8, ["colorCode", "imageLoadUrl"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).UpdateStatus)
              ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                  key: 2,
                  label: historyItemDataComputed.value.Value?.Value,
                  "is-dotted": "",
                  "bg-color": historyItemDataComputed.value.Value.ActionColor + '20',
                  "label-color": historyItemDataComputed.value.Value.ActionColor
                }, null, 8, ["label", "bg-color", "label-color"]))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).TransferTask)
              ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                  key: 3,
                  label: historyItemDataComputed.value.Value?.Value,
                  "is-dotted": "",
                  "bg-color": historyItemDataComputed.value.Value.ActionColor + '20',
                  "label-color": historyItemDataComputed.value.Value.ActionColor
                }, null, 8, ["label", "bg-color", "label-color"]))
              : _createCommentVNode("", true),
            (
                Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AttachTag ||
                Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).RemoveTag
              )
              ? (_openBlock(), _createBlock(_unref(TirPmStatus), {
                  key: 4,
                  label: historyItemDataComputed.value.Value?.Value,
                  "bg-color": historyItemDataComputed.value.Value.ActionColor + '20',
                  isBordered: "",
                  "label-color": historyItemDataComputed.value.Value.ActionColor
                }, null, 8, ["label", "bg-color", "label-color"]))
              : _createCommentVNode("", true),
            (Number(historyItemDataComputed.value.ActionType) == _unref(ActionEnum).AttachFile)
              ? (_openBlock(), _createBlock(_unref(TirPmFilePreview), {
                  key: 5,
                  file: computedFilePreview.value,
                  hideControls: ""
                }, null, 8, ["file"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(tirPmDateTransform)(historyItemDataComputed.value.DateCreated).format('DD.MM.YYYY')) + " в " + _toDisplayString(_unref(tirPmDateTransform)(new Date(historyItemDataComputed.value.DateCreated + 'Z')).format('HH:mm')), 1),
        _createVNode(_unref(TirPmTooltipElement), null, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.historyItemData.Performer.LastName) + " " + _toDisplayString(_ctx.historyItemData.Performer.FirstName) + " " + _toDisplayString(_ctx.historyItemData.Performer.MiddleName), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(TirPmIconView), {
              size: 24,
              isBordered: false,
              isRounded: "",
              colorCode: _ctx.historyItemData.Performer.AvatarColor,
              imageLoadUrl: _ctx.historyItemData.Performer.Photo
            }, {
              mainSlot: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.historyItemData.Performer.FirstName[0]) + _toDisplayString(_ctx.historyItemData.Performer.LastName[0]), 1)
              ]),
              _: 1
            }, 8, ["colorCode", "imageLoadUrl"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})